<template>
  <div v-if="enabled" class="wish-list-note">
    <div class="mountain-peak-container">
      <div class="mountain-peak" />
    </div>
    <div>
      <form method="post" class="wish-list-note__form" action="/lists/addNote">
        <CdrInput
          v-model="noteToShow"
          class="wish-list-note__input"
          label=""
          hide-label
          maxlength="200"
          :placeholder="placeHolder"
          :rows="4"
          @input="validateNote"
        />
        <fieldset class="wish-list-note__buttons">
          <CdrButton class="wish-list-note__buttons__save" @click="addNote"> Save </CdrButton>
          <CdrButton modifier="secondary" @click="hideSection"> Cancel </CdrButton>
        </fieldset>
      </form>
      <CdrButton modifier="link" @click="deleteNote"> Delete note </CdrButton>
    </div>
    {{ error }}
  </div>
</template>

<script>
import { CdrInput, CdrButton } from '@rei/cedar';

export default {
  name: 'HeadingComponent',
  components: {
    CdrInput,
    CdrButton,
  },
  props: {
    note: {
      type: String,
      default: '',
    },
    enabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      noteToShow: this.note,
      placeHolder: '200 character limit',
    };
  },
  mounted() {
    if (this.noteToShow) {
      this.placeHolder = this.noteToShow;
    }
  },
  methods: {
    hideSection() {
      this.$emit('hideFromButton', false);
    },
    validateNote(event) {
      this.noteToShow = event.target.value.replace(/[^a-zA-Z0-9\s',.!?\-+;:]/g, '');
    },
    addNote() {
      this.$emit('addComment', this.noteToShow);
      this.hideSection();
    },
    deleteNote() {
      this.$emit('addComment', '');
      this.noteToShow = '';
      this.hideSection();
    },
  },
};
</script>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens';

.wish-list-note {
  &__form {
    background: $cdr-color-background-secondary;
    margin-bottom: $cdr-space-one-x;
    padding: $cdr-space-one-x;
  }
  &__input {
    background: white;
    margin-bottom: $cdr-space-one-x;
  }
  &__buttons {
    &__save {
      margin-right: $cdr-space-quarter-x;
    }
  }
}
.mountain-peak {
  display: inline-block;
  position: relative;
  height: 3rem;
  transform: translateX(-60px);
  &::before,
  &::after {
    content: '';
    position: absolute;
    border-top-width: 0 !important;
    border-style: solid;
    border-color: transparent transparent $cdr-color-background-secondary;
  }
  &::before {
    border-width: 3rem;
  }
  &::after {
    border-width: 2rem;
    transform: translate(3.6rem, 1rem);
  }
  &-container {
    position: relative;
    text-align: center;
    transform: translateY(6px);
    width: 100%;
  }
}

@media screen and (min-width: $cdr-breakpoint-md) {
  .wish-list-note {
    transform: translateX(-110px);
  }
}
</style>
